import { createSlice } from '@reduxjs/toolkit';
import { DocumentaryStoreType } from './types/documentary-store';
import type { RootState } from './configureStore';

const initialState: DocumentaryStoreType = {
  clientSelected: null,
};

export const slice = createSlice({
  name: 'documentary',
  initialState: { ...initialState },
  reducers: {
    setClientSelected: (balance, action) => {
      balance.clientSelected = action.payload;
    },
    cleanData: () => initialState,
  },
});

export const { setClientSelected, cleanData } = slice.actions;
export default slice.reducer;

// Selectors
export const getClientSeleted = (state: RootState) =>
  state.entities.documentary.clientSelected;
